import { flow, Instance, types } from 'mobx-state-tree'
import { addPackageToMId } from '../../network/addPackageToMId'
import { deletePackageToMId } from '../../network/deletePackageToMId'
import { getAllPackageToMIds } from '../../network/getAllPackageToMIds'
import { getPackageToMIdById } from '../../network/getPackageToMIdById'
import { getVerifiedMId } from '../../network/getVerifiedMId'
import { pToMIdProcessApprovals } from '../../network/pToMIdProcessApprovals'
import { updatePackageToMId } from '../../network/updatePackageToMId'
import { getErrorMessage, MessageTypes } from '../../utils'
import { FORM_MESSAGE, ROUTING_PACKAGE_FILETYPE } from '../../utils/constants'
import { RootStore } from '../store'

const PackageMId = types.model('PackageMId', {
  type: types.optional(types.literal('package2MId'), 'package2MId'),
  id: types.maybeNull(types.number),
  mid: types.optional(types.string, ''),
  packageName: types.optional(types.string, ''),
})

const PackageToMId = types
  .model('PackageToMId', {
    packageMId: types.optional(PackageMId, {}),
    packageMIds: types.array(PackageMId),
  })
  .actions((self) => ({
    getAll: flow(function* getAll(data: any, paginationInfo: any) {
      try {
        const response = yield getAllPackageToMIds(data, paginationInfo)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    getById: flow(function* getById(id: string) {
      try {
        const response = yield getPackageToMIdById(id, RootStore.session.getTokens)
        const own = self
        own.packageMId = response
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    add: flow(function* add(data: any) {
      try {
        const response = yield addPackageToMId(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR, FORM_MESSAGE)
        throw error
      }
    }),
    bulkAddPackageToMid: flow(function* add(dataArary: any[]) {
      const apiResp: any[] = []
      for (let i = 0; i < dataArary.length; i++) {
        const requestBody = {
          mid: dataArary[i]?.['Merchant Id'],
          packageName: dataArary[i]?.['Package Name'],
          fileType: ROUTING_PACKAGE_FILETYPE,
        }
        try {
          const response = yield addPackageToMId(requestBody, RootStore.session.getTokens)
          apiResp.push({
            ...requestBody,
            status: response?.status,
            message: response?.message ?? response,
          })
        } catch (error) {
          console.log(error)
          apiResp.push({
            ...requestBody,
            status: error?.status ?? 'FAILED',
            message: error?.message ?? error,
          })
        }
      }
      return apiResp
    }),
    update: flow(function* update(data: any) {
      try {
        const response = yield updatePackageToMId(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR, FORM_MESSAGE)
        throw error
      }
    }),
    deletePackage: flow(function* deletePackage(data: any) {
      try {
        const response = yield deletePackageToMId(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(error?.message, MessageTypes.ERROR)
        throw error
      }
    }),

    processApprovals: flow(function* processApprovals(data: any) {
      try {
        const response = yield pToMIdProcessApprovals(data, RootStore.session.getTokens, ROUTING_PACKAGE_FILETYPE)
        RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),

    bulkProcessApprovals: flow(function* bulkProcessApprovals(dataArary: any[]) {
      const apiResp: any[] = []
      for (let i = 0; i < dataArary.length; i++) {
        try {
          const response = yield pToMIdProcessApprovals(
            dataArary[i],
            RootStore.session.getTokens,
            ROUTING_PACKAGE_FILETYPE,
          )
          apiResp.push({
            ...dataArary[i],
            approvalStatus: dataArary[i].status,
            status: response?.status,
            message: response?.message ?? response,
          })
        } catch (error) {
          console.log(error)
          apiResp.push({
            ...dataArary[i],
            approvalStatus: dataArary[i].status,
            status: error?.status ?? 'FAILED',
            message: error?.message ?? error,
          })
        }
      }
      return apiResp
    }),

    verifyMId: flow(function* verifyMId(mid: string) {
      try {
        const response = yield getVerifiedMId(mid, RootStore.session.getTokens, ROUTING_PACKAGE_FILETYPE)
        // RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
  }))
  .views((self) => ({
    getPackageMids() {
      return self.packageMIds.map((item: any) => {
        return {
          ...item,
          id: `${item.id}`,
          edit: 'edit',
          delete: 'delete',
        }
      })
    },
    getFilteredPackageToMidsList(listData: any, keys?: any, searchText?: any) {
      const list = listData ?? self?.packageMIds ?? []
      const data = list?.map((item: any) => {
        return {
          ...item,
          id: `${item.id}`,
          edit: 'edit',
          delete: 'delete',
        }
      })
      if (keys?.length > 0) {
        if (data.length > 0) {
          if (keys && keys?.length > 0) {
            const retArr: any = []
            data.map((item: any) => {
              let isMatching = true
              keys.map((obj: any) => {
                const val = isNaN(item[obj?.key]) ? item[obj?.key].toLowerCase() : item[obj?.key]?.toString()
                isMatching = isMatching && val.includes(obj?.searchString.toLowerCase())
              })
              isMatching && retArr.push(item)
              return retArr
            })
            return retArr
          } else {
            return list?.filter((obj: any) =>
              Object.keys(obj).some((key) => obj[key].toLowerCase().includes(searchText.toLowerCase())),
            )
          }
        }
      }
      return data
    },
  }))

const packageMIDData = PackageToMId.create({
  packageMId: {},
  packageMIds: [],
})

export type PackageToMIdType = Instance<typeof PackageToMId>

export { PackageMId, packageMIDData, PackageToMId }
